export const pronunciationItemKey = (item) => `${item?.word || ''}::${item?.sense_id || 'primary'}`;

export const createPronunciationCard = (item) => ({
  key: pronunciationItemKey(item),
  item,
  status: 'ready',
  hadFailure: false,
  feedback: null,
  error: '',
});

export const initializePronunciationBoard = (items, cardCount = 3) => {
  const source = [...(items || [])];
  return {
    cards: source.slice(0, cardCount).map(createPronunciationCard),
    pending: source.slice(cardCount),
  };
};

export const updatePronunciationCard = (cards, key, updates) => (
  cards.map((card) => (card.key === key ? { ...card, ...updates } : card))
);

export const pronunciationResultStatus = ({ passed, hadFailure, requireRelearn }) => {
  if (!passed) return 'failed';
  return hadFailure && requireRelearn ? 'relearn_ready' : 'passed';
};

export const confirmPronunciationCard = (board, key) => {
  const cardIndex = board.cards.findIndex((card) => card.key === key);
  if (cardIndex < 0 || board.cards[cardIndex].status !== 'passed') return board;

  const [replacement, ...remaining] = board.pending;
  if (!replacement) {
    return {
      cards: board.cards.filter((card) => card.key !== key),
      pending: remaining,
    };
  }

  return {
    cards: board.cards.map((card, index) => (
      index === cardIndex ? createPronunciationCard(replacement) : card
    )),
    pending: remaining,
  };
};
